<template>
  <div>
    <template v-if="elements !== null">
      <v-form ref="customSettingsForm">
        <v-container>
          <v-row no-gutters>

            <v-col cols="3">
              <label></label>
              <v-text-field variant="underlined" :disabled="varSettings.id != 0" class="pr-10" label="Имя переменной"
                v-model="varSettings.name" :rules="[
                  () =>
                    !!(
                      /^[A-Za-z0-9-]+$/.test(varSettings.name) ||
                      !varSettings.name
                    ) || 'Допустимы только символы a-z,0-9,-',
                ]"></v-text-field>
            </v-col>

            <v-col cols="4">
              <label></label>
              <v-text-field variant="underlined" class="pr-10" label="Описание"
                v-model="varSettings.description"></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-select variant="underlined" class="pt-5" v-model="varSettings.selectedType" :items="varType"
                item-title="name" item-value="type" label="Тип переменной" @update:modelValue="onSelectType($event)">
              </v-select>
            </v-col>
            <v-col cols="1" align-self="center" class="text-right">
              <v-icon title="clear" color="red lighten-2" @click="clear()">
                mdi-cancel
              </v-icon>
            </v-col>
          </v-row>

          <v-row v-if="varSettings.selectedType != null">


            <v-col v-if="varSettings.selectedType == 'list'">
              <v-textarea rows="1" row-height="24px" v-model="varSettings.value" auto-grow
                hint="Укажите возможные значения списка с разделителем |" persistent-hint="true"
                placeholder="Значение1|Значение2|Значение3"></v-textarea>
            </v-col>

            <v-col v-if="varSettings.selectedType == 'template'">
              <v-textarea rows="1" row-height="24px" v-model="varSettings.value" auto-grow></v-textarea>
            </v-col>

            <v-col v-if="varSettings.selectedType == 'group-by'">
              <v-select multiple style="max-height: 250px;" v-model="varSettings.value" :items="groupBy"
                item-title="name" item-value="id"></v-select>

            </v-col>
            <!--глобальная не редактируемая переменная, значение только здесь можно установить-->
            <v-col v-if="!['list', 'template', 'group-by'].includes(varSettings.selectedType) &&
              varSettings.global && !varSettings.canedit">
              <v-textarea rows="1" row-height="24px" v-model="varSettings.value" auto-grow></v-textarea>
            </v-col>


          </v-row>

          <v-row>
            <v-col cols="4" class="d-flex">
              <v-radio-group hide-details :disabled="varSettings.selectedType !== null &&
                (varSettings.selectedType == 'group-by' || varSettings.selectedType == 'template')
                " v-model="varSettings.type" column @change="findAvailableVars">
                <v-radio label="Документ" color="primary" value="custom-document"></v-radio>
                <v-radio label="Пользователь" color="primary" value="custom-person"></v-radio>
              </v-radio-group>
              <a href="https://www.procollege.ru/mod/page/view.php?id=203#doctype" target="_blank"
                class="align-self-center">
                <v-icon class="mb-4 text-black">mdi-chat-question</v-icon>
              </a>
            </v-col>

            <v-col cols="4" class="d-flex">
              <v-switch color="primary" v-model="varSettings.global" class="align-self-center switch">
                <template v-slot:label>
                  <span>Глобальная переменная</span>
                  <a href="https://www.procollege.ru/mod/page/view.php?id=203#global" target="_blank">
                    <v-icon class="mb-4 text-black">mdi-chat-question</v-icon>
                  </a>
                </template>
              </v-switch>
            </v-col>
            <v-col cols="4">
              <v-checkbox class="checkboxes" :disabled="varSettings.selectedType !== null &&
                (varSettings.selectedType == 'group-by' ||
                  varSettings.selectedType == 'template')
                " @click="toggleEditbale" v-model="varSettings.editable" label="Редактируемое" color="green" value="1"
                hide-details></v-checkbox>

              <v-checkbox class="checkboxes" :disabled="varSettings.selectedType !== null &&
                varSettings.selectedType == 'group-by'
                " @click="toggleViewable" v-model="varSettings.viewable" label="Показать значение" color="green"
                value="1" hide-details></v-checkbox>
            </v-col>
          </v-row>
        </v-container>

        <v-btn color="primary" @click.stop="saveVar(false)">
          <span v-if="varSettings.id == 0">Добавить переменную</span>
          <span v-else>Сохранить переменную</span>
        </v-btn>
      </v-form>
      <v-divider></v-divider>

      <v-data-table :items="elements">
        <template v-slot:headers>
          <tr>
            <td>имя</td>
            <td>описание</td>
            <td>глобальная</td>
            <td>относится к</td>
            <td></td>
          </tr>
        </template>
        <template v-slot:item="{ item }">
          <tr @click="editVar(item.id)" class="cursor-pointer">
            <td>{{ item.name }}</td>
            <td>{{ item.description }}</td>
            <td>
              <span v-if="item.global">Да</span>
              <span v-else>Нет</span>
            </td>
            <td>
              <span v-if="item.type == 'custom-document'">документ</span>
              <span v-else>студент</span>
            </td>
            <td>
              <v-icon title="Удалить" color="red lighten-2" @click="delVar(item.id)">
                mdi-delete
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
    </template>
    <template v-else>
      <v-skeleton-loader type="article"></v-skeleton-loader>
    </template>
    <confirmdlg ref="confirm" />
  </div>
</template>

<script>
import confirmDialog from 'moodleDir/procollege/lib/vue/confirm-dialog.vue';
export default {
  components: {
    confirmdlg: confirmDialog,
  },
  data() {
    return {
      varType: [
        {
          name: "текст",
          type: "raw",
        },
        {
          name: "дата",
          type: "date",
        },
        {
          name: "валюта",
          type: "money",
        },
        {
          name: "флаг",
          type: "checkbox",
        },
        {
          name: "список",
          type: "list",
        },
        {
          name: "список сотрудников",
          type: "staff-list",
        },
        {
          name: "группировка",
          type: "group-by",
        },
        {
          name: "шаблон",
          type: "template",
        },
      ],
      varSettings: {
        name: "",
        editable: false,
        viewable: false,
        description: "",
        selectedType: null,
        global: false,
        type: "custom-document",
        value: false,
        id: 0,
      },
      groupBy: [],
      validationErrors: null,
      elements: null, //глобальные переменные: данные студента и проч
    };
  },
  props: {
    categoryid: false,
  },
  created() {
    this.axios
      .post(
        this.$model.wwwroot + "/procollege/manage_groups/documents3/categoriesGetCustomVariables",
        new URLSearchParams({
          categoryid: this.categoryid,
        })
      )
      .then((response) => {
        this.settingsLoaded(response.data);
      })
      .catch((error) => {
        this.axiosDefaultErrorHandler(error);
      });

    this.$eventBus.$on("save-category", (categoryid) => {
      this.saveVar(true);
      this.$emit("update:saved", true);
    });

    this.$emit("update:saved", false);
  },
  methods: {
    toggleEditbale() {
      if (this.varSettings.editable) {
        this.varSettings.viewable = "1";
      }
    },
    toggleViewable() {
      if (!this.varSettings.viewable) {
        this.varSettings.editable = null;
      }
    },
    settingsLoaded(resp) {
      this.elements = resp.variables;
      this.groupBy = resp.groupBy;
    },
    findAvailableVars() {
      if (this.varSettings.type == "custom-person") {
        this.availableCompositeVariables = this.personCompositeVariables;
      } else {
        this.availableCompositeVariables = this.documentCompositeVariables;
      }
    },
    async saveVar(silent = false) {
      let { valid } = await this.$refs.customSettingsForm.validate();

      if (!valid || this.varSettings.selectedType == null) {
        if (!silent) {

          this.$eventBus.$emit("show-dialog", {
            title: "Ошибка",
            content: "Введены некорректные данные",
          });
        }
        return;
      }

      if (!this.varSettings.name || !this.varSettings.description) {
        if (!silent) {
          this.$eventBus.$emit("show-dialog", {
            title: "Ошибка",
            content: "Вы должны указать непустое значение имени переменной и описание",
          });

        }
        return;
      }

      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/categoriesSaveCustomVar",
          new URLSearchParams({
            categoryid: this.categoryid,
            data: JSON.stringify(this.varSettings)
          })
        )
        .then((response) => {
          this.settingsLoaded(response.data);
        })
        .catch((error) => {
          this.axiosDefaultErrorHandler(error);
        });
      this.clear();
    },
    async delVar(id) {

      if (
        await this.$refs.confirm.open(
          "Подтверждение",
          "Хотите удалить переменную?"
        )
      ) {
        this.axios
          .post(
            this.$model.wwwroot + "/procollege/manage_groups/documents3/categoriesDelCustomVar",
            new URLSearchParams({
              categoryid: this.categoryid,
              id: id
            })
          )
          .then((response) => {
            this.settingsLoaded(response.data);
          })
          .catch((error) => {
            this.axiosDefaultErrorHandler(error);
          });

      }
    },
    editVar(id) {
      this.elements.forEach((element) => {
        if (element.id == id) {
          this.varSettings.name = element.name;
          this.varSettings.description = element.description;
          this.varSettings.type = element.type;
          this.varSettings.global = !!element.global;

          this.varType.forEach((vtelement) => {
            if (vtelement.type == element.datatype) {
              this.varSettings.selectedType = vtelement.type;

              if (element.options && element.options.value) {
                this.varSettings.value = element.options.value;
              }

              this.varSettings.editable = element.editable.toString();
              this.varSettings.viewable = element.viewable.toString();
            }
          });
          this.varSettings.id = element.id;
        }
      });
    },
    onSelectType(event) {
      this.varSettings.value = "";
      if (this.varSettings.selectedType == "group-by") {
        this.varSettings.editable = "0";
        this.varSettings.viewable = "0";
        this.varSettings.type = "custom-document";
      }
    },
    clear() {
      this.varSettings.name = "";
      this.varSettings.editable = false;
      this.varSettings.viewable = false;
      this.varSettings.description = "";
      this.varSettings.selectedType = null;
      this.varSettings.global = false;
      this.varSettings.id = 0;
      this.varSettings.value = false;
    }
  },
};
</script>
<style scoped>
thead tr {
  background-color: #eaeaea;
}

.checkboxes :deep(.v-selection-control--density-default) {
  min-height: 40px;
}

.row-pointer tbody>tr {
  cursor: pointer;
}

.mdi-chat-question {
  font-size: 24px;
}

.switch :deep(.mdi-chat-question) {
  margin: 0 !important;
}
</style>
